import type { FavoritesSideRailItem } from '../types/FavoritesSideRailItem';

export function getFavoritesSideRailCandidateItems(
    items: FavoritesSideRailItem[],
    retainedItem: FavoritesSideRailItem | undefined,
    maxItems: number
): FavoritesSideRailItem[] {
    const candidateItems = items.slice(0, maxItems);
    if (retainedItem && !candidateItems.some(item => item.key === retainedItem.key)) {
        candidateItems.push(retainedItem);
    }
    return candidateItems;
}

export function getVisibleFavoritesSideRailItems(
    candidateItems: FavoritesSideRailItem[],
    retainedItemKey: string | undefined,
    itemHeights: ReadonlyMap<string, number>,
    maxHeight: number,
    itemGap: number
): FavoritesSideRailItem[] | undefined {
    if (maxHeight <= 0) {
        return [];
    }

    let totalHeight = 0;
    const visibleItems: FavoritesSideRailItem[] = [];
    for (const item of candidateItems) {
        const itemHeight = itemHeights.get(item.key);
        if (itemHeight === undefined) {
            return undefined;
        }

        const slotHeight = itemHeight + (visibleItems.length > 0 ? itemGap : 0);
        if (totalHeight + slotHeight > maxHeight) {
            break;
        }

        totalHeight += slotHeight;
        visibleItems.push(item);
    }

    if (
        !retainedItemKey ||
        visibleItems.some(item => item.key === retainedItemKey) ||
        !candidateItems.some(item => item.key === retainedItemKey)
    ) {
        return visibleItems;
    }

    const retainedItem = candidateItems.find(item => item.key === retainedItemKey);
    const retainedItemHeight = itemHeights.get(retainedItemKey);
    if (!retainedItem) {
        return visibleItems;
    }
    if (retainedItemHeight === undefined) {
        return undefined;
    }

    if (retainedItemHeight > maxHeight) {
        return [];
    }

    while (visibleItems.length > 0 && totalHeight + itemGap + retainedItemHeight > maxHeight) {
        const removedItem = visibleItems.pop();
        if (!removedItem) {
            break;
        }

        const removedItemHeight = itemHeights.get(removedItem.key);
        if (removedItemHeight === undefined) {
            return undefined;
        }

        totalHeight -= removedItemHeight;
        if (visibleItems.length > 0) {
            totalHeight -= itemGap;
        }
    }

    return [...visibleItems, retainedItem];
}
